import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-center h-screen" }
const _hoisted_2 = { class: "w-1/2" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "mb-2" }

import {
    IonPage,
    IonContent 
} from '@ionic/vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import PasswordInput from '@/components/inputs/PasswordInput.vue';

import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';

import { ref, onMounted } from 'vue';
import Storage from '@/helpers/storage';
import AuthService from "@/classes/AuthService";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref()
const errors = ref([])

const form = ref({
    email: '',
    password: '',
})

const redirectToPage = () => {
    const hasDashboardPermission = window.$hasPermission('view-dashboard');
    
    if(hasDashboardPermission) {
        window.location.replace('/home');
    } else {
        // Redirect to the content management if cms admin
        window.location.replace('/contents/packages');
    }
}
const login = () => {
    loader.value = true;

    AuthService.login(form.value.email, form.value.password)
    .then((result: any) => {
        loader.value = false;

        if(result.data.access_token) {
            const tokens = new Storage();
            const accessToken = `${result.data.token_type} ${result.data.access_token}`;
            const hybrainToken = result.data.hybrain;

            tokens.set('access_token', accessToken)
            tokens.set('hybrain_token', hybrainToken)
            tokens.set('admin', JSON.stringify(result.data.admin))
            tokens.set('permissions', JSON.stringify(result.data.permissions));

            redirectToPage();
        }
    }).catch( (err: any) => {
        loader.value = false;
        showError.value = true;
        errorMsg.value = err.response.data.message;

        if(err.response.status == 422) {
            errors.value = err.response.data.errors;
        }
    })
}

onMounted(() => {
    setTimeout(() => {
        caches.delete('shinagawa-admin');
    }, 1000);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        fullscreen: true,
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "w-1/2 text-center px-20" }, [
              _createElementVNode("div", { class: "logo-img" }, [
                _createElementVNode("img", {
                  src: "assets/logo.png",
                  alt: "logo",
                  class: "w-full max-w-[500px]"
                })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("form", {
                class: "w-[60%] mx-auto",
                onSubmit: _withModifiers(login, ["prevent"])
              }, [
                _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-lg font-bold" }, "Admin", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm text-gray-500 mb-6" }, "Kindly input your credentials to continue", -1)),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(TextInput, {
                    type: "email",
                    id: "email",
                    name: "email",
                    modelValue: form.value.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.email) = $event)),
                    label: "Email Address",
                    placeholder: "Email Address",
                    autocomplete: "email",
                    autofocus: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(PasswordInput, {
                    id: "password",
                    name: "password",
                    modelValue: form.value.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.password) = $event)),
                    label: "Password",
                    placeholder: "Password"
                  }, null, 8, ["modelValue"])
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex items-center justify-end mb-6" }, [
                  _createElementVNode("a", {
                    href: "/forgot-password",
                    class: "text-xs m-0"
                  }, "Forgot Password?")
                ], -1)),
                _createVNode(ButtonComponent, {
                  type: 'submit',
                  class: "w-full"
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" Login ", -1)
                  ]))]),
                  _: 1
                })
              ], 32)
            ])
          ]),
          (loader.value)
            ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Warning!",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"])
    ]),
    _: 1
  }))
}
}

})